import { Grid, GridRow, GridColumn, LazyLoader } from '@bp/ui-components';
import { graphql } from 'client/gql';
import { BpCard } from 'components/BpCard/BpCard';
import { BpSubpage } from 'components/BpSubpage/BpSubpage';
import { ClassbookEvent } from 'components/Classbook/components/ClassbookEvents/ClassbookEvent';
import { Timetable } from 'components/Timetable/Timetable';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useState, Suspense } from 'react';
import { useQuery } from 'urql';

const ClassbookCoursesSubpagePageQueryDocument = graphql(`
  query ClassbookCoursesSubpagePageData($profile: ID!) {
    ...PermissionCheckerFields
  }
`);

export const ClassbookCoursesSubpage = () => {
  const { pimAuthClaims } = useAuthClaims();
  const profileUuid = pimAuthClaims.getProfile().uuid;
  const organization = pimAuthClaims.getOrganization();

  const [eventUuid, setEventUuid] = useState<string | null>(null);

  const [{ data }] = useQuery({
    query: ClassbookCoursesSubpagePageQueryDocument,
    variables: {
      profile: profileUuid,
    },
  });

  const permissions = usePermissionChecker(data);

  function handleEventClick(eventUuid: string) {
    setEventUuid(eventUuid);
  }

  return (
    <BpSubpage isForbidden={!permissions?.canViewClassbookCoursesAndClasses(organization)}>
      <Grid>
        <GridRow mobileGap='var(--grid-column-gap)'>
          <GridColumn width={4}>
            <BpCard>
              <Timetable showDaySelect showLegend hideTodayHighlight days={1} onEventClick={handleEventClick} />
            </BpCard>
          </GridColumn>
          <GridColumn width={8}>
            <Suspense fallback={<LazyLoader embedded size='xxl' transparent forceHeight='40vh' />}>
              <ClassbookEvent key={eventUuid} eventUuid={eventUuid} />
            </Suspense>
          </GridColumn>
        </GridRow>
      </Grid>
    </BpSubpage>
  );
};
